import { doc, onSnapshot, Timestamp } from "firebase/firestore";
import { useEffect, useRef, useState } from "react";
import { fireStore } from "../../firebase";

export const useOnUpdateCorporateEvent = (
	shouldStartUpdating: boolean,
	callback: () => void,
	corporateEventId: string,
) => {
	const [eventUpdated, setEventUpdated] = useState<Timestamp | null>(null);
	const lastProcessedMillisRef = useRef<number | null>(null);

	useEffect(() => {
		let unsubscribe: () => void;
		if (fireStore && corporateEventId && shouldStartUpdating) {
			const documentRef = doc(fireStore, "corporateEvents", corporateEventId);
			unsubscribe = onSnapshot(documentRef, (snap) => {
				if (snap.exists()) {
					setEventUpdated(snap.data().updatedAt);
				}
			});
		}
		return () => unsubscribe && unsubscribe();
	}, [shouldStartUpdating, corporateEventId]);

	useEffect(() => {
		if (!eventUpdated || !shouldStartUpdating) return;
		const millis = typeof eventUpdated?.toMillis === "function" ? eventUpdated.toMillis() : Number(eventUpdated);
		if (millis === lastProcessedMillisRef.current) return;
		lastProcessedMillisRef.current = millis;
		callback();
	}, [eventUpdated, shouldStartUpdating, callback]);
};
